import React, { useState, useEffect } from "react";
import {
  Grid,
  // CheckSquare,

  // Folder,
  // ShoppingCart,
  // FileText,
  // Activity,
} from "feather-icons-react/build/IconComponents";
import { Link, useParams } from "react-router-dom";
import { Dropdown, Skeleton } from "antd";
import { ChevronDown } from "feather-icons-react/build/IconComponents";
import ReactApexChart from "react-apexcharts";

import ProjectNotes from "./ProjectNotes";
import dayjs from "dayjs";
import { BASE_CRM_URL } from "../../../components/config/config";
import ProjectTasks from "./ProjectTasks";
import ProjectActivityLog from "./ProjectActivityLog";
import ProjectFileUpload from "./ProjectFileUpload";
import ProjectInvoices from "./ProjectSales/ProjectInvoices";
import ProjectEstimates from "./ProjectSales/ProjectEstimates";
import ProjectExpenses from "./ProjectSales/ProjectExpenses";
import ProjectProposal from "./ProjectSales/ProjectProposal";

const ProjectView = () => {
  const { id: projectId } = useParams();

  const [activeTab, setActiveTab] = useState("overview");
  const [project, setProject] = useState(null);

  console.log(project, "projecttttttt");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const timeItems = [
    { key: "1", label: "Today" },
    { key: "2", label: "This Week" },
    { key: "3", label: "This Month" },
    { key: "4", label: "This Year" },
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "45%",
        borderRadius: 4,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    },
    yaxis: {
      min: 0,
      max: 60,
      tickAmount: 10,
      labels: {
        formatter: (val) => `${val}m`,
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val} Minutes`,
      },
    },
    colors: ["#0d6efd"],
    grid: {
      borderColor: "#f1f1f1",
    },
  };

  const series = [
    {
      name: "Logged Time",
      data: [12, 25, 40, 30, 55, 18, 45],
    },
  ];

  const fetchProjectDetails = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await fetch(
        `${BASE_CRM_URL}/project/GetProjectDetails?ProId=${projectId}`,
      );

      if (!response.ok) {
        throw new Error("Failed to fetch project details");
      }

      const data = await response.json();

      if (data?.Status && data?.ResultData?.length > 0) {
        setProject(data.ResultData[0]);
      } else {
        setProject(null);
        setError(data?.Message || "Project details not found");
      }
    } catch (error) {
      console.error("Error fetching project details:", error);
      setError("Unable to load project details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (projectId) {
      fetchProjectDetails();
    }
  }, [projectId]);

  const formatDate = (date) => {
    if (!date || dayjs(date).year() < 2000) {
      return "N/A";
    }

    return dayjs(date).format("DD/MM/YYYY");
  };

  const formatDateTime = (date) => {
    if (!date || dayjs(date).year() < 2000) {
      return "N/A";
    }

    return dayjs(date).format("DD/MM/YYYY HH:mm");
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "New":
        return "bg-secondary-subtle text-secondary";

      case "InProgress":
      case "In Progress":
        return "bg-primary-subtle text-primary";

      case "On Hold":
        return "bg-warning-subtle text-warning";

      case "Finished":
        return "bg-success-subtle text-success";

      case "Cancelled":
        return "bg-danger-subtle text-danger";

      default:
        return "bg-secondary-subtle text-secondary";
    }
  };

  const getDaysLeft = (deadline) => {
    if (!deadline) return 0;

    return dayjs(deadline).startOf("day").diff(dayjs().startOf("day"), "day");
  };

  const getProjectTimeProgress = (startDate, deadline) => {
    if (!startDate || !deadline) return 0;

    const start = dayjs(startDate).startOf("day");
    const end = dayjs(deadline).startOf("day");
    const today = dayjs().startOf("day");

    const totalDays = end.diff(start, "day");
    const elapsedDays = today.diff(start, "day");

    if (totalDays <= 0) return 0;

    return Math.min(
      100,
      Math.max(0, Math.round((elapsedDays / totalDays) * 100)),
    );
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <nav aria-label="breadcrumb">
            <div className="d-flex justify-content-between align-items-center ">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/crm/Dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <h4 className="breadcrumb-item mb-0" aria-current="page">
                  View Project -{" "}
                  <b className="text-primary"> {project?.name || "N/A"}</b>
                </h4>
              </ol>
              <ul
                className="nav nav-tabs nav-tabs-bottom mb-3"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "overview" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("overview")}
                    role="tab"
                  >
                    {/* <Grid className="me-2" /> */}
                    OverView
                  </Link>
                </li>
                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "task" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("task")}
                    role="tab"
                  >
                    {/* <CheckSquare className="me-2" /> */}
                    Tasks
                  </Link>
                </li>

                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "note" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("notes")}
                    role="tab"
                  >
                    {/* <FileText className="me-2" /> */}
                    Notes
                  </Link>
                </li>
                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "activity" ? "active" : ""
                    }`}
                    activity
                    onClick={() => setActiveTab("activitylog")}
                    role="tab"
                  >
                    {/* <Activity className="me-2" /> */}
                    Activity
                  </Link>
                </li>
                {/* <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "sales" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("sales")}
                    role="tab"
                  >
                    <ShoppingCart className="me-2" />
                    Sales
                  </Link>
                </li> */}
                <li className="nav-item dropdown" role="presentation">
                  <Link
                    className={`nav-link dropdown-toggle ${
                      [
                        "proposals",
                        "estimates",
                        "invoices",
                        "expenses",
                      ].includes(activeTab)
                        ? "active"
                        : ""
                    }`}
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Sales
                  </Link>

                  <ul className="dropdown-menu">
                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={() => setActiveTab("proposals")}
                      >
                        Proposals
                      </Link>
                    </li>

                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={() => setActiveTab("estimates")}
                      >
                        Estimates
                      </Link>
                    </li>

                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={() => setActiveTab("invoices")}
                      >
                        Invoices
                      </Link>
                    </li>

                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={() => setActiveTab("expenses")}
                      >
                        Expenses
                      </Link>
                    </li>
                  </ul>
                </li>

                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "files" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("files")}
                    role="tab"
                  >
                    {/* <Folder className="me-2" /> */}
                    Files
                  </Link>
                </li>

                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "sales" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("sales")}
                    role="tab"
                  >
                    {/* <ShoppingCart className="me-2" /> */}
                    MileStone
                  </Link>
                </li>
              </ul>
              <div className="d-flex align-items-end">
                <Link
                  to="/crm/projects"
                  className="btn btn-secondary btn-sm me-2 mb-2"
                >
                  <i className="ti ti-arrow-left"></i>
                </Link>
              </div>
            </div>
          </nav>
          <div className="mt-2">
            <div className="card shadow-sm">
              {/* <div className="card-title mt-4 ms-3 me-4 d-flex justify-content-between align-items-center flex-wrap">
                {loading ? (
                  <div className="d-flex align-items-center">
                    <Skeleton.Avatar active size={45} shape="circle" />

                    <div className="ms-3">
                      <Skeleton.Input
                        active
                        size="small"
                        style={{ width: 220 }}
                      />
                    </div>
                  </div>
                ) : project ? (
                  <div className="d-flex align-items-center">
                    <i className="fa-solid fa-folder-open me-2"></i>
                    <h3 className="text-secondary mb-0">
                      {project.name || "N/A"}
                    </h3>
                  </div>
                ) : null}

               
              </div> */}

              <div className="card-body">
                <div className="tab-content ">
                  {activeTab === "overview" && (
                    <>
                      <div className="mt-1" style={{ marginTop: "-2rem" }}>
                        <div className="row">
                          {/* Left Column */}
                          <div className="col-lg-6">
                            <div className="card border-0 shadow-sm">
                              <div className="card-header bg-white">
                                <h5 className="mb-0">
                                  <Grid
                                    className="me-2 text-primary"
                                    size={18}
                                  />
                                  Project Overview
                                </h5>
                              </div>

                              <div className="card-body">
                                {loading ? (
                                  <div className="row">
                                    {[1, 2, 3, 4, 5, 6, 7].map((item) => (
                                      <div className="col-md-6 mb-4" key={item}>
                                        <Skeleton.Input
                                          active
                                          size="small"
                                          style={{
                                            width: 80,
                                            marginBottom: 8,
                                          }}
                                        />

                                        <br />

                                        <Skeleton.Input
                                          active
                                          size="small"
                                          style={{
                                            width: "70%",
                                          }}
                                        />
                                      </div>
                                    ))}

                                    <div className="col-12">
                                      <Skeleton.Input
                                        active
                                        size="small"
                                        style={{
                                          width: 100,
                                          marginBottom: 10,
                                        }}
                                      />

                                      <Skeleton
                                        active
                                        paragraph={{
                                          rows: 3,
                                        }}
                                        title={false}
                                      />
                                    </div>
                                  </div>
                                ) : project ? (
                                  <div className="row">
                                    {/* Project # */}
                                    <div className="col-md-6 mb-3">
                                      <label className="text-muted small">
                                        Project #
                                      </label>

                                      <h6>{project.id || "N/A"}</h6>
                                    </div>

                                    {/* Customer */}
                                    <div className="col-md-6 mb-3">
                                      <label className="text-muted small">
                                        Customer
                                      </label>

                                      <h6>{project.ClientCompany || "N/A"}</h6>
                                    </div>

                                    {/* Status */}
                                    <div className="col-md-6 mb-3">
                                      <label className="text-muted small">
                                        Status
                                      </label>

                                      <br />

                                      <span
                                        className={`badge ${getStatusClass(
                                          project.StatusName,
                                        )}`}
                                      >
                                        {project.StatusName || "N/A"}
                                      </span>
                                    </div>

                                    {/* Date Created */}
                                    <div className="col-md-6 mb-3">
                                      <label className="text-muted small">
                                        Date Created
                                      </label>

                                      <h6>
                                        {formatDate(project.project_created)}
                                      </h6>
                                    </div>

                                    {/* Start Date */}
                                    <div className="col-md-6 mb-3">
                                      <label className="text-muted small">
                                        Start Date
                                      </label>

                                      <h6>{formatDate(project.start_date)}</h6>
                                    </div>

                                    {/* Deadline */}
                                    <div className="col-md-6 mb-3">
                                      <label className="text-muted small">
                                        Deadline
                                      </label>

                                      <h6>{formatDate(project.deadline)}</h6>
                                    </div>

                                    {/* Completed Date */}
                                    <div className="col-md-6 mb-3">
                                      <label className="text-muted small">
                                        Completed Date
                                      </label>

                                      <h6>
                                        {formatDateTime(project.date_finished)}
                                      </h6>
                                    </div>

                                    {/* Description */}
                                    <div className="col-12">
                                      <label className="text-muted small">
                                        Description
                                      </label>

                                      <div className="border rounded p-3 bg-light">
                                        {project.description || "N/A"}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="text-center text-muted py-4">
                                    {error || "No project details found"}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Right Column */}
                          <div className="col-lg-6">
                            {/* Project Card */}

                            <div className="row">
                              {/* Tasks */}
                              <div className="col-6">
                                <div className="card border-0 shadow mb-3">
                                  <div className="card-body text-start">
                                    {loading ? (
                                      <>
                                        <Skeleton.Input
                                          active
                                          size="small"
                                          style={{ width: 130 }}
                                        />

                                        <div className="mt-2">
                                          <Skeleton.Input
                                            active
                                            size="small"
                                            style={{ width: 60 }}
                                          />
                                        </div>

                                        <Skeleton.Input
                                          active
                                          size="small"
                                          block
                                          style={{
                                            height: 5,
                                            marginTop: 10,
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <small className="text-muted">
                                          {Number(project?.TotalTasks || 0) -
                                            Number(
                                              project?.CompletedTasks || 0,
                                            )}{" "}
                                          / {project?.TotalTasks || 0} Open
                                          Tasks
                                        </small>

                                        <h5 className="text-success fw-bold mt-2">
                                          {project?.TotalTasks > 0
                                            ? Math.round(
                                                (Number(
                                                  project.CompletedTasks || 0,
                                                ) /
                                                  Number(project.TotalTasks)) *
                                                  100,
                                              )
                                            : 0}
                                          %
                                        </h5>

                                        <div
                                          className="progress mt-2"
                                          style={{ height: 5 }}
                                        >
                                          <div
                                            className="progress-bar bg-success"
                                            style={{
                                              width: `${
                                                project?.TotalTasks > 0
                                                  ? Math.round(
                                                      (Number(
                                                        project.CompletedTasks ||
                                                          0,
                                                      ) /
                                                        Number(
                                                          project.TotalTasks,
                                                        )) *
                                                        100,
                                                    )
                                                  : 0
                                              }%`,
                                            }}
                                          />
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>

                              {/* Days Left */}
                              <div className="col-6">
                                <div className="card border-0 shadow">
                                  <div className="card-body text-start">
                                    {loading ? (
                                      <>
                                        <Skeleton.Input
                                          active
                                          size="small"
                                          style={{ width: 130 }}
                                        />

                                        <div className="mt-2">
                                          <Skeleton.Input
                                            active
                                            size="small"
                                            style={{ width: 60 }}
                                          />
                                        </div>

                                        <Skeleton.Input
                                          active
                                          size="small"
                                          block
                                          style={{
                                            height: 5,
                                            marginTop: 10,
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <>
                                        {(() => {
                                          const daysLeft = getDaysLeft(
                                            project?.deadline,
                                          );

                                          const timeProgress =
                                            getProjectTimeProgress(
                                              project?.start_date,
                                              project?.deadline,
                                            );

                                          return (
                                            <>
                                              <small className="text-muted">
                                                {daysLeft < 0
                                                  ? `${Math.abs(daysLeft)} Days Overdue`
                                                  : `${daysLeft} Days Left`}
                                              </small>

                                              <h5
                                                className={`fw-bold mt-2 ${
                                                  daysLeft < 0
                                                    ? "text-danger"
                                                    : "text-success"
                                                }`}
                                              >
                                                {timeProgress}%
                                              </h5>

                                              <div
                                                className="progress mt-2"
                                                style={{ height: 5 }}
                                              >
                                                <div
                                                  className={`progress-bar ${
                                                    daysLeft < 0
                                                      ? "bg-danger"
                                                      : "bg-success"
                                                  }`}
                                                  style={{
                                                    width: `${timeProgress}%`,
                                                  }}
                                                />
                                              </div>
                                            </>
                                          );
                                        })()}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <div>
                                <h5 className="mb-0">
                                  Total Logged Hours (Demo)
                                </h5>
                                <small className="text-muted">42h 30m</small>
                              </div>

                              <Dropdown
                                menu={{ items: timeItems }}
                                trigger={["click"]}
                              >
                                <a
                                  href="/#"
                                  onClick={(e) => e.preventDefault()}
                                  className="text-decoration-none text-dark fw-semibold"
                                >
                                  This Week{" "}
                                  <ChevronDown size={16} className="ms-1" />
                                </a>
                              </Dropdown>
                            </div>
                            <div className="card">
                              <div className="card-body">
                                <ReactApexChart
                                  options={options}
                                  series={series}
                                  type="bar"
                                  height={200}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {activeTab === "task" && (
                    <>
                      <ProjectTasks CustomerData={project} />
                    </>
                  )}
                  {activeTab === "attachments" && (
                    <div className="mt-1">
                      <div className="row">
                        <div className="col-12">
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                              border: "2px dashed #007bff",
                              padding: "40px",
                              textAlign: "center",
                            }}
                          >
                            <a
                              href="#"
                              style={{ fontSize: "18px", color: "#007bff" }}
                            >
                              Drag files here to upload
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {activeTab === "notes" && (
                    <>
                      <ProjectNotes />
                    </>
                  )}
                  {activeTab === "activitylog" && (
                    <>
                      <ProjectActivityLog />
                    </>
                  )}
                  {activeTab === "files" && (
                    <>
                      <ProjectFileUpload CustomerData={project} />
                    </>
                  )}

                  {activeTab === "proposals" && (
                    <ProjectProposal projectId={projectId} />
                  )}

                  {activeTab === "estimates" && (
                    <ProjectEstimates projectId={projectId} />
                  )}

                  {activeTab === "invoices" && (
                    <ProjectInvoices projectId={projectId} />
                  )}

                  {activeTab === "expenses" && (
                    <ProjectExpenses projectId={projectId} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <>{/* <SetARemind /> */}</>
      </div>
    </>
  );
};

export default ProjectView;
